import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    padding: ${theme.v3.spacing.xxxs};
    border-radius: ${theme.v3.border.radius.xl};
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${theme.v3.spacing.sm};
    position: relative;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      flex-direction: column;
      align-items: center;
      padding: 0;
    }

    &::before {
      @media (min-width: ${theme.v3.breakpoints.md}) {
        content: '';
        position: absolute;
        background: ${theme.v3.colors.brand.snappyBlue[80]};
        top: -250px;
        right: -250px;
        width: 400px;
        height: 400px;
        border-radius: 50%;
        filter: blur(115px);
        pointer-events: none;
        z-index: 0;
      }
    }

    &::after {
      content: '';
      position: absolute;
      background: ${theme.v3.colors.accent.green[90]};
      bottom: -250px;
      right: -250px;
      width: 400px;
      height: 400px;
      border-radius: 50%;
      filter: blur(115px);
      pointer-events: none;
      z-index: 0;
    }
  `}
`;

export const Content = styled.div`
  ${({ theme }) => css`
    width: 100%;
    min-width: 550px;
    max-width: 50%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${theme.v3.spacing.xs};  

    @media (max-width: ${theme.v3.breakpoints.md}) {
      min-width: 100%;
      max-width: 100%;
      align-items: center;
    }
  `}
`;

export const About = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.v3.spacing.nano};
`;

export const Title = styled.h3`
  ${({ theme }) => css`
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes['1xlarge']};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.confortable};
    color: ${theme.v3.colors.brand.snappyBlue[10]};
    margin: 0;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes.large};
    }
  `}
`;

export const Description = styled.div`
  ${({ theme }) => css`
    margin: 0;

    p {
      font-family: ${theme.v3.font.family.brand};
      font-size: ${theme.v3.font.sizes.medium};
      font-weight: ${theme.v3.font.weights.regular};
      line-height: ${theme.v3.font.lineHeight.comfortable};
      color: ${theme.v3.colors.neutral[20]};

      @media (max-width: ${theme.v3.breakpoints.md}) {
        font-size: ${theme.v3.font.sizes.small};
      }

      &:first-child {
        margin-top: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  `}
`;

export const SelectPanel = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.v3.spacing.xxxs};
    margin-top: ${theme.v3.spacing.nano};
    width: 100%;
  `};
`;

export const SelectPanelTitle = styled.div`
  ${({ theme }) => css`
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.confortable};
    color: ${theme.v3.colors.brand.snappyBlue[10]};
    margin: 0;
  `}
`;

export const SelectPanelList = styled.div`
  ${({ theme }) => css`
    width: 100%;
    max-width: 600px;
    display: flex;
    flex-wrap: wrap;
    gap: ${theme.v3.spacing.xxxs};

    > div {
      flex: 0 0 calc(50% - ${theme.v3.spacing.xxxs});
      border-radius: ${theme.v3.border.radius.lg};

      @media (max-width: ${theme.v3.breakpoints.md}) {
        flex: 0 0 100%;
      }       
    }
  `}    
`;

export const SelectPanelItem = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: ${theme.v3.spacing.nano};
    padding: ${theme.v3.spacing.xxxs};
    border-radius: ${theme.v3.border.radius.lg};
    border: 1px solid ${theme.v3.colors.neutral[90]};
    cursor: pointer;
    user-select: none;
    transition: .3s;

    &:hover {
      background: ${theme.v3.colors.brand.snappyBlue[95]};
      border-color: ${theme.v3.colors.brand.snappyBlue[95]};
    }
  `}
`;

export const SelectPanelItemIcon = styled.img`
  width: 40px;
  height: 40px;
  display: block;
`;

export const SelectPanelItemName = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.medium};
    color: ${theme.v3.colors.neutral[20]};
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes.small};
    }    
  `}
`;

export const SelectPanelItemTag = styled.span`
  ${({ theme }) => css`
    text-transform: uppercase;
    font-size: ${theme.v3.font.sizes.mini};
    font-weight: ${theme.v3.font.weights.bold};
    color: ${theme.v3.colors.brand.snappyBlue[20]};
    border-radius: ${theme.v3.border.radius.round};
    background: linear-gradient(90deg, ${theme.v3.colors.brand.snappyBlue[60]}, ${theme.v3.colors.accent.green[90]});
    padding: 0 ${theme.v3.spacing.nano};
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  `}
`;

export const ActionButton = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: flex-start;
    align-items: center;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      justify-content: center;
    }
  `}
`;

export const ImageWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 10;  
    right: -40px;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      right: -24px;
    }    
  `}
`;

export const Image = styled.img`
  max-width: 100%;
  max-height: 370px;
  height: auto;
  display: block;
`;
